import dayjs from "dayjs";
import store from "@/store";
import { zendeskWidgetUrl } from "@/constants/zendesk";

const lastAuthDateKey = "occ_lastAuthDate";

export const saveZendeskLastAuthDate = () => {
  localStorage.setItem(lastAuthDateKey, String(new Date()));
};

export const getZendeskLastAuthDate = () => {
  const lastAuthDate = localStorage.getItem(lastAuthDateKey);
  if (!lastAuthDate) {
    return undefined;
  }
  return new Date(lastAuthDate);
};

export const removeZendeskLastAuthDate = () => {
  localStorage.removeItem(lastAuthDateKey);
};

export const requireZendeskReAuth = () => {
  // zendeskのssoは1分間に10回までという制限があるため、8時間は再認証をしないように制御
  const expirationHoursTerm = 8;

  const zendeskLastAuthDate = getZendeskLastAuthDate();
  if (!zendeskLastAuthDate) return true;

  const hoursDiff = dayjs().diff(dayjs(zendeskLastAuthDate), "hours");
  return hoursDiff > expirationHoursTerm;
};

export const createZESettings = (
  name?: string,
  email?: string
): ZendeskSettings => ({
  webWidget: {
    position: { horizontal: "right", vertical: "bottom" },
    // NOTE: contactFormの初期値
    contactForm: {
      fields: [
        {
          id: "name",
          prefill: { "*": name || "" }
        },
        { id: "email", prefill: { "*": email || "" } }
      ]
    }
  }
});

export const setZendeskWidget = (): void => {
  let partnerUser = store.state.domains.user.partnerUser;

  if (window.zE) {
    window.zE("webWidget", "show");
  } else {
    require("@/assets/styles/zendesk.scss");
    const zendeskScript = document.createElement("script");
    zendeskScript.setAttribute("src", zendeskWidgetUrl);
    zendeskScript.setAttribute("Key", "zendesk");
    zendeskScript.setAttribute("id", "ze-snippet");
    document.head.appendChild(zendeskScript);
  }

  if (!partnerUser || !partnerUser.email) return;

  const name = partnerUser.partner.company.name;
  const email = partnerUser.email;
  window.zESettings = createZESettings(name, email);
};

export const resetZendeskWidget = (): void => {
  window.zE && window.zE("webWidget", "hide");
};
